/**
 * @file 认证流程
 * @author wangzhuang
 */
import React from 'react';
import {connect} from 'react-redux';
import {withRouter, Prompt} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Form, FormItem, Upload, Checkbox, Spin, Toast, Modal, Tips} from '@baidu/spui';
import Steps from './steps';
import Xmod from './xmod';
import Viewmod from './viewmod';
import './index.less';
import {fetchAuth, fetchSendCode, fetchCheckphone} from '../../actions/attestAction';
import {location} from './location';
import demo from '../../asset/img/单位号码证明函模板.docx';
import {checkNumber} from '../../../src/components/util';

const cascaderOptionData = [];

for (let attr in location[0]) {
    let children = [];
    for (let attr2 in location[`0,${attr}`]) {
        children.push({
            value: `${location[0][attr]},${location[`0,${attr}`][attr2]}`,
            name: location[`0,${attr}`][attr2]
        });
    }

    cascaderOptionData.push({
        value: location[0][attr],
        name: location[0][attr],
        children: children
    });
}

class AttestStep extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            myStep: this.props.match.params.num - 1,
            attestType: '2',
            name: '1',
            checkboxValue2: false,
            magnifyOff: false,
            logoId: false,
            spinOff: false,
            icpId: false,
            promptOff: true,
            trademarkId: false, // 商标
            magnifySrc: '',
            formData: {},
            formData2: {
                display: '',
                phone: '',
                name: '', // 企业名称
                province: '', // 省份
                city: '', // 城市
                address: '', // 详细地址
                industry: '', // 行业分类
                companyQualifyId: false, // 企业资质
                companyQperatorId: false, // 运营商证明
                certOtherId: false, // 其他证明
                certOther2Id: false, // d单位证明函
                email: '', // 邮箱
                code: '', // 邮箱验证码
                tel: '', // 手机
                tel_code: '', // 手机验证码
                website: '', // 网址
                icpId: false // icp

            },
            logoError: '',
            icpError: '',
            companyQualifyError: '', // 企业资质报错
            companyQperatorError: '', // 运营商证明报错
            certOtherError: '',
            certOther2Error: '', // 单位证明函报错
            trademarkError: '',
            modTop: 290,
            codeOff: false,
            codeTime: 60,
            telTime: 60,
            codeOff1: false,
            Iscommit: false,
            phoneArr: [{key: Date.now()}]
        };
    }

    componentDidMount() {

        let {num, type} = this.props.match.params;

        if (num === '2' && !type) {
            this.props.history.push('/attest/step/1');
        }
        window.scrollTo(0, 0);

        this.scrollFn();
        window.addEventListener('scroll', this.scrollFn);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            promptOff: nextProps.match.params.num !== '3'
        });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', null);
    }

    scrollFn = () => {
        let scrollTop = document.documentElement.scrollTop;
        if (scrollTop > 150) {
            this.setState({
                modTop: 110
            });
        } else {
            this.setState({
                modTop: 270 - scrollTop
            });
        }
    };

    formItemGetValue = ({name, value}) => {
        this.setState({
            formData: {
                ...this.state.formData,
                [name]: value
            }
        });
    };

    formItemGetValue2 = ({name, value}) => {
        this.setState({
            formData2: {
                ...this.state.formData2,
                [name]: value
            }
        });
        this.checked(name, value);
    };

    onChange = ({name, value}) => {
        this.setState({[name]: value});
    };

    checkName = obj => {
        let value = obj.value;
        let v = value.replace(/(^\s*)|(\s*$)/g, '');

        if (v.length > 0 && v.length < 12) {
            this.props.fetchCheckphone({
                type: 3,
                display: value
            }).then(data => {
                if (data.code !== 200) {
                    Modal.confirm({
                        title: '展示名称已被认证',
                        buttonReverse: true,
                        maskClosable: true,
                        buttonType: 0,
                        singleButton: true,
                        warningType: true,
                        okText: '好的',
                        className: 'spui-modal-other',
                        children: <div>
                            {data.message}
                        </div>
                    });

                } else {
                    this.setState({
                        nameOff: true
                    });
                }
            });
        }
    };

    sendCodeFn = (type) => {
        let formData2 = this.state.formData2;
        let tcode = type === 1 ? 'codeTime' : 'telTime';
        let offt = type === 1 ? 'codeOff' : 'codeOff1';

        window.BCat_2055 && window.BCat_2055.miao();
        window['__abbaidu_2055_cb'] = responseData => {
            window['___abbaidu_2055_cb'] = null;
            let localData = JSON.parse(responseData);
            this.props.fetchSendCode({
                type: type,
                data: localData.data,
                'key_id': localData['key_id'],
                sign: localData.sign,
                verity: type === 1 ? formData2.email : formData2.tel
            }).then(data => {
                if (data.code === 200) {
                    let timer = setInterval(() => {
                        let codeTime = this.state[tcode];
                        if (codeTime > 1) {
                            this.setState({
                                [tcode]: codeTime - 1
                            });
                        } else {
                            clearInterval(timer);
                            this.setState({
                                [tcode]: 60,
                                [offt]: false
                            });
                        }
                    }, 1000);
                } else {
                    this.setState({
                        [tcode]: 60,
                        [offt]: false
                    });
                    Toast.display({
                        type: 'error',
                        info: data.message,
                        delay: 3500
                    });
                }

            });
        };
    };
    checked = (n, value) => {
        let {
            phone,
            // name, // 企业名称
            // province, // 省份
            // address, // 详细地址
            // industry, // 行业分类
            // companyQualifyId, // 企业资质
            // companyQperatorId, // 运营商证明
            certOther2Id, // 单位证明函
            // email, // 邮箱
            // code, // 验证码
            tel, // 手机
            tel_code, // 手机验证码
            display, // 展示名称
            // website,
            // icpId
        } = this.state.formData2;
        // let flag = false;
        let checkboxValue2 = this.state.checkboxValue2;
        // let checkp = {
        //     phone, name, industry, companyQualifyId, companyQperatorId,
        //     certOther2Id, email, code, tel, tel_code, display, checkboxValue2,
        //     website, icpId

        // };
        let checkp = {
            phone,
            certOther2Id, tel, tel_code, display, checkboxValue2,
        };
        checkp[n] = value;
        // if (checkp.website || checkp.icpId) {
        //     flag = false;
        // } else {
        //     flag = true;
        // }
        for (let prop in checkp) {
            // if (flag && (prop === 'icpId' || prop === 'website')) {
            //     continue;
            // }
            if (!checkp[prop]) {
                this.setState({
                    Iscommit: false
                });
                return;
            }
        }
        this.setState({
            Iscommit: true
        });

    };

    submit = async vlidate => {
        const {
            phone,
            name, // 企业名称
            // province, // 省份
            // address, // 详细地址
            // industry, // 行业分类
            // companyQualifyId, // 企业资质
            // companyQperatorId, // 运营商证明
            // certOtherId, // 其他证明
            certOther2Id, // 单位证明函
            // email, // 邮箱
            // code, // 验证码
            tel, // 手机
            tel_code, // 手机验证码
            display, // 展示名称
            // website, // 网址
            // icpId // icp
        } = this.state.formData2;

        // if (!companyQualifyId) {
        //     return this.setState({
        //         companyQualifyError: '请上传单位合法资质'
        //     });
        // } else {
        //     this.setState({
        //         companyQualifyError: false
        //     });
        // }
        if (!certOther2Id) {
            return this.setState({
                certOther2Error: '请上传单位证明函'
            });
        } else {
            this.setState({
                certOther2Error: false
            });
        }
        // if (!companyQperatorId) {
        //     return this.setState({
        //         companyQperatorError: '请上传运营商证明'
        //     });
        // } else {
        //     this.setState({
        //         companyQperatorError: false
        //     });
        // }
        if (vlidate) {
            window.BCat_2055 && window.BCat_2055.miao();
            window['__abbaidu_2055_cb'] = responseData => {
                let localData = JSON.parse(responseData);
                let json = {
                    step: 2, // 步骤
                    type: 2, // 认证类型
                    data: localData.data,
                    'key_id': localData['key_id'],
                    sign: localData.sign,
                    // name,
                    // email,
                    // code,
                    display, // 展示名称
                    phone, // 电话
                    tel,
                    tel_code,
                    // province: province.split(',')[0],
                    // city: province.split(',')[1],
                    // 'company_qualify_id': [companyQualifyId],
                    // 'company_operator_id': [companyQperatorId],
                    // 'industry': industry.label,
                    'cert_other_2': [certOther2Id],
                    'is_read': 1
                };
                // if (certOtherId) {
                //     json['cert_other_1'] = [certOtherId];
                // }
                // if (website) {
                //     json.website = website;
                // }
                // if (icpId) {
                //     json.icp_id = [icpId];
                // }
                this.setState({spinOff: true});
                this.props.fetchAuth(json).then(data => {
                    this.setState({spinOff: false});
                    if (data.code === 200) {
                        this.setState({promptOff: false}, () => {
                            this.props.history.push('/attest/step/2');
                        });
                    } else {
                        Toast.display({
                            type: 'error',
                            info: data.message,
                            delay: 3500
                        });
                    }
                });
            };
        }
    };

    // companyQperatorChange(data) {
    //     const formData2 = this.state.formData2;
    //     let file = data.value;
    //     if (file.type.substr(-3) !== 'png'
    //         && data.value.type.substr(-4) !== 'jpeg') {
    //         this.setState({
    //             companyQualifyError: '格式不正确'
    //         });
    //         return false;
    //     }
    //     if (file.size > (1024 * 1024 * 10)) { // 1M
    //         Toast.display({
    //             type: 'error',
    //             info: '图片大小过大',
    //             delay: 3500
    //         });
    //         return false;
    //     }

    //     this.setState({
    //         companyQualifyError: ''
    //     });

    //     file.formDatas.append('product_id', 'haoma');
    //     file.formDatas.append('is_spot', 'YES');

    //     let myInit = {
    //         method: 'POST',
    //         credentials: 'include',
    //         body: file.formDatas
    //     };

    //     fetch('/api/v1/image', myInit)
    //         .then(response => response.json())
    //         .then(response => {
    //             if (response.code === 200) {
    //                 formData2.companyQualifyId = response.data.id;
    //                 formData2.name = response.data.name;
    //                 this.setState({
    //                     formData2: formData2
    //                 });
    //                 this.checked('companyQualifyId', response.data.id);
    //             } else {
    //                 Toast.display({
    //                     type: 'error',
    //                     info: response.message,
    //                     delay: 3500
    //                 });

    //             }
    //         });
    // }

    render() {
        let {num} = this.props.match.params;
        let urlStr = '/api/v1/image/get?product_id=haoma&img_id=';
        let {
            spinOff, codeOff, codeTime, promptOff,
            formData, formData2, codeOff1, telTime,
            companyQperatorError, certOtherError, icpError,
            companyQualifyError, checkboxValue2, Iscommit,
            modTop, magnifyOff, magnifySrc, certOther2Error
        } = this.state;
        let reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
        let reg1 = /^1[3456789]\d{9}$/;
        let reg2 = /^(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&amp;:/~+#]*[\w\-@?^=%&amp;/~+#])?$/;

        let phoneData = [];
        for (let attr in formData) {
            if (attr.indexOf('phone') !== -1) {
                phoneData.push(formData[attr]);
            }
        }
        return (
            <div className={'attest'}>
                {num === '1'
                    ? <div>
                        <div className={'mod2'}>
                            <div className="top-title">政府/非盈利机构 号码免费认证</div>
                            <div>
                                <Steps current={num}/>
                            </div>
                            <div className={'mod2-from'}>
                                <Form submit={this.submit} ref={el => (this.myFrom = el)} className={'width-960'}>
                                    {/* <div className={'jb'}>
                                        <span className={'blue'}></span>
                                        <span>基本信息</span>
                                    </div> */}
                                    {/* <div className={'spui2-input-root margin-bottom-24'}>
                                        <div className={'from-mod-left spui2-form-label'}>
                                            <i className={'star'}>*</i><span>认证类型</span>
                                        </div>
                                        <div style={{display: 'inline-block', lineHeight: '40px'}}>
                                            特殊认证通道
                                        </div>
                                    </div> */}
                                    {/* <FormItem
                                        type="input"
                                        value={formData2.name}
                                        spellCheck={false}
                                        name={'name'}
                                        horizontal={true}
                                        label={<span><i className={'star'}>*</i>单位名称</span>}
                                        placeHolder={'需与单位证明函上鲜章的单位名称一致，长度不超过20个字符'}
                                        rules={
                                            [
                                                {
                                                    validate(value) {
                                                        let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                        return v.length === 0;
                                                    },
                                                    message: '此项不能为空！'
                                                },
                                                {
                                                    validate(value) {
                                                        return value.length > 20;
                                                    },
                                                    message: '单位名称长度不能超过20'
                                                },
                                                {
                                                    validate(value) {
                                                        if (!~value.indexOf('自来水') && !~(value.indexOf('燃气'))) {
                                                            return value.endsWith('有限公司');
                                                        }

                                                    },
                                                    message: '该企业暂不支持特殊认证，如有疑问，请添加QQ群725854778，私信管理员处理'
                                                }

                                            ]
                                        }
                                        onBlur={obj => {
                                            let value = obj.value;
                                            const userInfo = this.props.userInfo;
                                            if (
                                                value
                                                && userInfo.code === 200
                                                && userInfo.data.is_history_user) {
                                                this.props.fetchCheckphone({
                                                    type: 3,
                                                    display: value
                                                }).then(data => {
                                                    if (data.code !== 200 && !data.data.data) {
                                                        Modal.confirm({
                                                            title: '单位名称已被认证',
                                                            buttonReverse: true,
                                                            maskClosable: true,
                                                            buttonType: 0,
                                                            singleButton: true,
                                                            warningType: true,
                                                            okText: '好的',
                                                            className: 'spui-modal-other',
                                                            children: <div>
                                                                {data.message}
                                                            </div>
                                                        });
                                                    }
                                                });
                                            }
                                        }}
                                        getValue={this.formItemGetValue2}
                                    /> */}
                                    <FormItem
                                        type="input"
                                        value={formData2.display}
                                        spellCheck={false}
                                        name={'display'}
                                        horizontal={true}
                                        rules={
                                            [
                                                {
                                                    validate(value) {
                                                        let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                        return v.length === 0;
                                                    },
                                                    message: '此项不能为空！'
                                                }
                                            ]
                                        }
                                        label={<span><i className={'star'}>*</i>展示名称</span>}
                                        placeHolder={'请输入展示名称'}
                                        getValue={this.formItemGetValue2}
                                    />
                                    {/* <FormItem
                                        value={formData2.industry}
                                        type="select"
                                        width={400}
                                        name="industry"
                                        label={<span><i className={'star'}>*</i>行业类型</span>}
                                        placeHolder={'请选择行业类型'}
                                        cancelIcon
                                        optionData={[
                                            {id: 1, label: '教育'},
                                            {id: 2, label: '卫生、医疗和社会工作'},
                                            {id: 3, label: '文化、体育和娱乐'},
                                            {id: 4, label: '旅游、住宿、餐饮和出行'},
                                            {id: 5, label: '公共管理、社会保障和社会组织'},

                                        ]}
                                        getValue={this.formItemGetValue2}
                                        rules={
                                            [
                                                {
                                                    validate(value) {
                                                        return !value || (!value.label);
                                                    },
                                                    message: '此项不能为空！'
                                                }
                                            ]
                                        }
                                    /> */}
                                    <FormItem
                                        type="input"
                                        value={formData2.phone}
                                        name={'phone'}
                                        horizontal={true}
                                        label={<span><i className={'star'}>*</i>认证号码</span>}
                                        placeHolder={'请输入座机、手机、400/800、95/96、1010号码(仅限一个)'}
                                        onBlur={obj => {
                                            let value = obj.value;

                                            if (
                                                checkNumber(value)
                                            ) {
                                                this.props.fetchCheckphone({
                                                    type: 2,
                                                    phone: value
                                                }).then(data => {
                                                    if (data.code !== 200) {
                                                        Modal.confirm({
                                                            title: '号码已被认证',
                                                            buttonReverse: true,
                                                            maskClosable: true,
                                                            buttonType: 0,
                                                            singleButton: true,
                                                            warningType: true,
                                                            okText: '好的',
                                                            className: 'spui-modal-other',
                                                            children: <div>
                                                                {data.message}
                                                            </div>
                                                        });
                                                    } else {
                                                        this.setState({});
                                                    }
                                                });
                                            }
                                        }}
                                        rules={
                                            [
                                                {
                                                    validate(value) {
                                                        let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                        return v.length === 0;
                                                    },
                                                    message: '此项不能为空！'
                                                },
                                                {
                                                    validate(value) {
                                                        return !checkNumber(value);
                                                    },
                                                    message: <span>
                                                        <span>号码格式有误，支持座机/手机、400/800、95/96、1010号码！</span>
                                                        <span style={{display: 'block'}}>
                                                            如有疑问，请添加QQ群725854778，私信管理员处理。
                                                        </span>
                                                    </span>
                                                },
                                                {
                                                    validate(value) {
                                                        // phoneData
                                                        let numVal = 0;

                                                        phoneData.forEach(item => {
                                                            if (item === value) {
                                                                numVal++;
                                                            }
                                                        });

                                                        return numVal > 1;

                                                    },
                                                    message: '认证号码不能重复！'
                                                }
                                            ]
                                        }
                                        getValue={this.formItemGetValue2}
                                    />
                                    {/* <div className={'jb'} style={{marginTop: '20px'}}>
                                        <span className={'blue'}></span>
                                        <span>文件上传</span>
                                    </div> */}
                                    {/* <div className={'from-mod mt20 pb24 dwh'}>
                                        <div className={'from-mod-left'}>
                                            <i className={'star'}>*</i><span>单位合法资质</span>
                                        </div>
                                        <div className={'from-mod-right pr'}>
                                            <Upload
                                                fileId={'feui-companyQualifyIdx'}
                                                uploadType={'image-upload'}
                                                noWarning={true}
                                                name={'image'}
                                                width={'96px'}
                                                height={'96px'}
                                                onHandleChange={this.companyQperatorChange.bind(this)}
                                            />
                                            {formData2.companyQualifyId
                                                ? <div
                                                    className={'load-mod'}
                                                    style={{
                                                        backgroundImage: `url(${
                                                            urlStr + formData2.companyQualifyId})`
                                                    }}
                                                    onClick={() => {
                                                        this.setState({
                                                            magnifySrc: `${urlStr + formData2.companyQualifyId}`,
                                                            magnifyOff: true
                                                        });
                                                    }}
                                                >
                                                    <div
                                                        className={'close'}
                                                        onClick={e => {
                                                            formData2.companyQualifyId = false;
                                                            this.setState({
                                                                formData2: formData2
                                                            });
                                                            this.checked('companyQualifyId', false);
                                                            e.stopPropagation();
                                                        }}
                                                    />
                                                </div>
                                                : null
                                            }
                                            {
                                                companyQualifyError
                                                    ? <div style={{
                                                        position: 'relative',
                                                        top: '5px'
                                                    }}
                                                    className="spui2-form-warning">
                                                        <i className="spui2-input-error"/>
                                                        <span>{companyQualifyError}</span>
                                                    </div>
                                                    : null
                                            }
                                            <div
                                                className={'shangbiao'}
                                                onClick={() => {
                                                    this.setState({
                                                        magnifySrc: require('../../asset/img/attest/zizhi.jpg'),
                                                        magnifyOff: true
                                                    });
                                                }}
                                            >
                                                <img src={require('../../asset/img/attest/zizhi.jpg')} alt=""/>
                                                <span>上传样例</span>
                                                <i/>
                                            </div>
                                            <div
                                                className={'icon-text'}
                                                style={{width: '400px', position: 'relative', left: '0'}}>
                                                <div>
                                                    <span>
                                                        上传说明：单位合法资质用于证明该企业性质以及合法性
                                                    </span><br/><br/>
                                                    <span>
                                                        上传要求：请上传最新的单位资质, 仅支持jpg或png格式，大小不超过10M
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    { /* <FormItem
                                        type={'cascader'}
                                        label={<span><i className={'star'}>*</i>企业地址</span>}
                                        width={400}
                                        name={'province'}
                                        optionData={cascaderOptionData}
                                        placeHolder={'和企业资质保持一致'}
                                        value={formData2.province}
                                        dropdownItemWidth={133.999}
                                        getValue={this.formItemGetValue2}
                                        rules={
                                            [
                                                {
                                                    validate(value) {
                                                        return value.length === 0;
                                                    },
                                                    message: '此项不能为空！'
                                                }
                                            ]
                                        }
                                    />
                                    <FormItem
                                        type="textarea"
                                        name={'address'}
                                        width={'400px'}
                                        spellCheck={false}
                                        value={formData2.address}
                                        resize={false}
                                        hidden={false}
                                        label={' '}
                                        countWay="character"
                                        countComplete={true}
                                        placeHolder={'请填写详细企业地址，请确保为实际办公地址'}
                                        rules={
                                            [
                                                {
                                                    validate(value) {
                                                        let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                        return v.length === 0;
                                                    },
                                                    message: '此项不能为空！'
                                                }
                                            ]
                                        }
                                        getValue={this.formItemGetValue2}
                                    /> */}

                                    <div
                                        className={'from-mod mt30 pb24'}
                                        style={certOther2Error ? {height: '223px'} : {height: '200px'}}>
                                        <div className={'from-mod-left'}>
                                            <i className={'star'}>*</i><span>单位证明函</span>
                                        </div>
                                        <div className={'from-mod-right pr'}>
                                            <Upload
                                                fileId={'feui-certOther2Id'}
                                                uploadType={'image-upload'}
                                                noWarning={true}
                                                name={'image'}
                                                width={'96px'}
                                                height={'96px'}
                                                onHandleChange={data => {
                                                    let file = data.value;
                                                    if (file.type.substr(-3) !== 'png'
                                                        && data.value.type.substr(-4) !== 'jpeg') {
                                                        this.setState({
                                                            certOther2Error: '格式不正确'
                                                        });
                                                        return false;
                                                    }
                                                    if (file.size > (1024 * 1024 * 10)) { // 1M
                                                        Toast.display({
                                                            type: 'error',
                                                            info: '图片大小过大',
                                                            delay: 3500
                                                        });
                                                        return false;
                                                    }

                                                    this.setState({
                                                        certOther2Error: ''
                                                    });

                                                    file.formDatas.append('product_id', 'haoma');
                                                    file.formDatas.append('is_spot', 'NO');

                                                    let myInit = {
                                                        method: 'POST',
                                                        credentials: 'include',
                                                        body: file.formDatas
                                                    };

                                                    fetch('/api/v1/image', myInit)
                                                        .then(response => response.json())
                                                        .then(response => {
                                                            if (response.code === 200) {
                                                                formData2.certOther2Id = response.data.id;
                                                                this.setState({
                                                                    formData2: formData2
                                                                });
                                                                this.checked(
                                                                    'certOther2Id', response.data.id
                                                                );
                                                            } else {
                                                                Toast.display({
                                                                    type: 'error',
                                                                    info: response.message,
                                                                    delay: 3500
                                                                });

                                                            }
                                                        });
                                                }}
                                            />
                                            {formData2.certOther2Id
                                                ? <div
                                                    className={'load-mod'}
                                                    style={{
                                                        backgroundImage: `url(${urlStr + formData2.certOther2Id})`
                                                    }}
                                                    onClick={() => {
                                                        this.setState({
                                                            magnifySrc: `${urlStr + formData2.certOther2Id}`,
                                                            magnifyOff: true
                                                        });
                                                    }}
                                                >
                                                    <div
                                                        className={'close'}
                                                        onClick={e => {
                                                            formData2.certOther2Id = false;
                                                            this.setState({
                                                                formData2: formData2
                                                            });
                                                            this.checked('certOther2Id', false);
                                                            e.stopPropagation();
                                                        }}
                                                    />
                                                </div>
                                                : null
                                            }
                                            {
                                                certOther2Error
                                                    ? <div style={{
                                                        position: 'relative',
                                                        top: '5px'
                                                    }}
                                                    className="spui2-form-warning">
                                                        <i className="spui2-input-error"></i>
                                                        <span>{certOther2Error}</span>
                                                    </div>
                                                    : null
                                            }
                                            <div style={{marginTop: '16px'}}>
                                                <a
                                                    className={'down'}
                                                    href={demo}
                                                    download={'单位号码证明函模板.docx'}>模板下载
                                                </a>
                                            </div>
                                            <div
                                                className={'icon-text'}
                                            >
                                                <div>
                                                    <span>上传说明：单位证明函用于证实该企业名称合法有效</span><br/>
                                                    <span>上传要求：证明函需要盖单位鲜章,仅支持jpg或png格式，大小不超过10M</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={'form-mod2'}>
                                        <div>
                                            {/* <div
                                                className={'from-mod mt20 pb24'}
                                                style={{height: '245px'}}
                                            >
                                                <div className={'from-mod-left'}>
                                                    <i className={'star'}>*</i> <span>号码运营商证明</span>
                                                </div>
                                                <div className={'from-mod-right pr'}>
                                                    <Upload
                                                        fileId={'feui-certOtherId'}
                                                        uploadType={'image-upload'}
                                                        noWarning={true}
                                                        name={'image'}
                                                        width={'96px'}
                                                        height={'96px'}
                                                        onHandleChange={data => {
                                                            let file = data.value;
                                                            if (file.type.substr(-3) !== 'png'
                                                                && data.value.type.substr(-4) !== 'jpeg') {
                                                                this.setState({
                                                                    companyQperatorError: '图片格式不正确'
                                                                });
                                                                return false;
                                                            }

                                                            if (file.size > (1024 * 1024 * 10)) { // 1M
                                                                Toast.display({
                                                                    type: 'error',
                                                                    info: '图片大小过大',
                                                                    delay: 3500
                                                                });
                                                                return false;
                                                            }

                                                            this.setState({
                                                                companyQperatorError: ''
                                                            });

                                                            file.formDatas.append('product_id', 'haoma');
                                                            file.formDatas.append('is_spot', 'NO');

                                                            let myInit = {
                                                                method: 'POST',
                                                                credentials: 'include',
                                                                body: file.formDatas
                                                            };

                                                            fetch('/api/v1/image', myInit)
                                                                .then(response => response.json())
                                                                .then(response => {
                                                                    if (response.code === 200) {
                                                                        formData2.companyQperatorId = response.data.id;
                                                                        this.setState({
                                                                            formData2: formData2
                                                                        });
                                                                        this.checked(
                                                                            'companyQperatorId',
                                                                            response.data.id);
                                                                    } else {
                                                                        Toast.display({
                                                                            type: 'error',
                                                                            info: response.message,
                                                                            delay: 3500
                                                                        });

                                                                    }
                                                                });
                                                        }}
                                                    />
                                                    {formData2.companyQperatorId
                                                        ? <div
                                                            className={'load-mod'}
                                                            style={{
                                                                backgroundImage: `url(${
                                                                    urlStr + formData2.companyQperatorId
                                                                })`
                                                            }}
                                                            onClick={() => {
                                                                this.setState({
                                                                    magnifySrc: `${urlStr
                                                                    + formData2.companyQperatorId}`,
                                                                    magnifyOff: true
                                                                });
                                                            }}
                                                        >
                                                            <div
                                                                className={'close'}
                                                                onClick={e => {
                                                                    formData2.companyQperatorId = false;
                                                                    this.setState({
                                                                        formData2: formData2
                                                                    });
                                                                    this.checked('companyQperatorId', false);
                                                                    e.stopPropagation();
                                                                }}
                                                            />
                                                        </div>
                                                        : null
                                                    }
                                                    {
                                                        companyQperatorError
                                                            ? <div style={{
                                                                position: 'relative',
                                                                top: '5px'
                                                            }}
                                                            className="spui2-form-warning">
                                                                <i className="spui2-input-error"></i>
                                                                <span>{companyQperatorError}</span>
                                                            </div>
                                                            : null
                                                    }
                                                    <div
                                                        className={'shangbiao'}
                                                        onClick={() => {
                                                            this.setState({
                                                                magnifySrc: require('../../asset/img/'
                                                                    + 'attest/400ruwang.jpg'),
                                                                magnifyOff: true
                                                            });
                                                        }}
                                                    >
                                                        <img
                                                            src={require('../../asset/img/'
                                                                + 'attest/400ruwang.jpg')}
                                                            alt=""/>
                                                        <span>上传样例</span>
                                                        <i/>
                                                    </div>
                                                    <div
                                                        className={'shangbiao'}
                                                        style={{left: '250px'}}
                                                        onClick={() => {
                                                            this.setState({
                                                                magnifySrc: require('../../asset/'
                                                                    + 'img/attest/yunying.png'),
                                                                magnifyOff: true
                                                            });
                                                        }}
                                                    >
                                                        <img src={require('../../asset/img/attest/yunying.png')}
                                                            alt=""/>
                                                        <span>上传样例</span>
                                                        <i/>
                                                    </div>
                                                    <div
                                                        className={'icon-text'}
                                                        style={{width: '400px', position: 'relative', left: '0'}}
                                                    >
                                                        <div style={{marginTop: '25px', lineHeight: '20px'}}>
                                                            <span>上传说明：运营商证明用于证实该企业号码真实有效</span><br/><br/>
                                                            <span>上传要求：号码入网协议、缴费发票、号码归属证明3选1即可（材料上的单位名称需与展示名称一致,
                                                                如您提交的号码归属不是所认证的企业主体,需提交
                                                                其他企业的授权证明等信息）,仅支持jpg或png格式，大小不超过10M
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                                            {/* <div>
                                                <div className={'jb'}>
                                                    <span className={'blue'}></span>
                                                    <span>网站信息</span>
                                                </div>
                                                <div className={'Pweb'}>
                                                    <FormItem
                                                        type="input"
                                                        value={formData2.website}
                                                        spellCheck={false}
                                                        name={'website'}
                                                        horizontal={true}
                                                        label={formData2.icpId || formData2.website
                                                            ? <span><i className={'star'}>*</i>企业网站地址:</span>
                                                            : <span>企业网站地址:</span>

                                                        }
                                                        placeHolder={'请输入企业网站地址'}
                                                        rules={
                                                            [
                                                                {
                                                                    validate(value) {
                                                                        return value && !reg2.test(value);
                                                                    },
                                                                    message: '网站地址格式不正确！'
                                                                },
                                                                {
                                                                    validate(value) {
                                                                        if (formData2.icpId) {
                                                                            let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                            return v.length === 0;

                                                                        }
                                                                    },
                                                                    message: '网站地址不能为空！'
                                                                }

                                                            ]
                                                        }
                                                        getValue={this.formItemGetValue2}
                                                    />
                                                    <div
                                                        className={'icon-text webt'}
                                                    >
                                                        提交后可以通过点击结果展示企业网站(限pc浏览器),提高审核通过率
                                                    </div>
                                                </div>
                                                <div
                                                    className={'from-mod mt20 pb24'}
                                                    style={{height: icpError ? '270px' : '240px'}}
                                                >
                                                    <div className={'from-mod-left'}>
                                                        {(formData2.website || formData2.icpId)
                                                        && <i className={'star'}>*</i>}
                                                        <span>icp备案(非icp许可证):</span>
                                                    </div>
                                                    <div className={'from-mod-right pr'}>
                                                        <Upload
                                                            fileId={'feui-icpId'}
                                                            uploadType={'image-upload'}
                                                            noWarning={true}
                                                            name={'image'}
                                                            width={'96px'}
                                                            height={'96px'}
                                                            onHandleChange={data => {
                                                                let file = data.value;
                                                                if (data.value.type.substr(-4) !== 'jpeg') {
                                                                    this.setState({
                                                                        icpError: '图片格式不正确'
                                                                    });
                                                                    return false;
                                                                }

                                                                if (file.size > (1024 * 1024 * 10)) { // 1M
                                                                    Toast.display({
                                                                        type: 'error',
                                                                        info: '图片大小过大',
                                                                        delay: 3500
                                                                    });
                                                                    return false;
                                                                }

                                                                this.setState({
                                                                    icpError: ''
                                                                });

                                                                file.formDatas.append('product_id', 'haoma');
                                                                file.formDatas.append('is_spot', 'NO');

                                                                let myInit = {
                                                                    method: 'POST',
                                                                    credentials: 'include',
                                                                    body: file.formDatas
                                                                };

                                                                fetch('/api/v1/image', myInit)
                                                                    .then(response => response.json())
                                                                    .then(response => {
                                                                        if (response.code === 200) {
                                                                            formData2.icpId = response.data.id;
                                                                            this.setState({
                                                                                formData2: formData2
                                                                            });
                                                                            this.checked(
                                                                                'icpId',
                                                                                response.data.id);
                                                                        } else {
                                                                            Toast.display({
                                                                                type: 'error',
                                                                                info: response.message,
                                                                                delay: 3500
                                                                            });

                                                                        }
                                                                    });
                                                            }}
                                                        />
                                                        {formData2.icpId
                                                            ? <div
                                                                className={'load-mod'}
                                                                style={{
                                                                    backgroundImage: `url(${
                                                                        urlStr + formData2.icpId})`
                                                                }}
                                                                onClick={() => {
                                                                    this.setState({
                                                                        magnifySrc: `${urlStr
                                                                        + formData2.icpId}`,
                                                                        magnifyOff: true
                                                                    });
                                                                }}
                                                            >
                                                                <div
                                                                    className={'close'}
                                                                    onClick={e => {
                                                                        formData2.icpId = false;
                                                                        this.setState({
                                                                            formData2: formData2
                                                                        });
                                                                        this.checked('icpId', false);
                                                                        e.stopPropagation();
                                                                    }}
                                                                />
                                                            </div>
                                                            : null
                                                        }
                                                        {
                                                            icpError
                                                                ? <div style={{
                                                                    position: 'relative',
                                                                    top: '5px'
                                                                }}
                                                                className="spui2-form-warning">
                                                                    <i className="spui2-input-error"/>
                                                                    <span>{icpError}</span>
                                                                </div>
                                                                : null
                                                        }
                                                        <div
                                                            className={'shangbiao'}
                                                            onClick={() => {
                                                                this.setState({
                                                                    magnifySrc: require('../../asset/img'
                                                                        + '/attest/ICP.jpg'),
                                                                    magnifyOff: true
                                                                });
                                                            }}
                                                        >
                                                            <img
                                                                src={require('../../asset/img/attest/ICP.jpg')}
                                                                alt=""/>
                                                            <span>上传样例</span>
                                                            <i/>
                                                        </div>
                                                        <div
                                                            className={'icon-text'}
                                                            style={{width: '400px', position: 'relative', left: '0'}}>
                                                            <div className={'webtip'}>
                                                                <span>
                                                                    上传要求：
                                                                </span><br/>
                                                                <span>
                                                                    1.请提交完整的icp备案截图,截图要求是企业备案详情页,且带有工信部网站域名信息,参考上传样例;
                                                                </span><br/>
                                                                <span>
                                                                    2.未通过下述站点查询的截图结果一律判定为无效资质,查询地址:
                                                                </span><br/>
                                                                <a
                                                                    className={'down'}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    href={'https://beian.miit.gov.cn/#/'
                                                                    + 'integrated/recordQuery'}>
                                                                    https://beian.miit.gov.cn/#/integrated/
                                                                    recordQuery</a>
                                                                <br/>
                                                                <span>
                                                                    3.仅支持.jpg图片格式，大小不超过10MB
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                                            {/* <div className={'jb'}>
                                                <span className={'blue'}></span>
                                                <span>邮箱/手机验证</span>
                                            </div> */}

                                            {/* <FormItem
                                                type="input"
                                                value={formData2.email}
                                                spellCheck={false}
                                                name={'email'}
                                                horizontal={true}
                                                label={<span><i className={'star'}>*</i>联系邮箱</span>}
                                                placeHolder={'请输入正确的邮箱地址用来接收系统通知'}
                                                rules={
                                                    [
                                                        {
                                                            validate(value) {
                                                                let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                return v.length === 0;
                                                            },
                                                            message: '此项不能为空！'
                                                        },
                                                        {
                                                            validate(value) {
                                                                return !reg.test(value);
                                                            },
                                                            message: '联系邮箱格式不正确！'
                                                        }
                                                    ]
                                                }
                                                getValue={this.formItemGetValue2}
                                            /> */}

                                            {/* <FormItem
                                                type="input"
                                                value={formData2.code}
                                                spellCheck={false}
                                                name={'code'}
                                                horizontal={true}
                                                width={'120px'}
                                                label={<span><i className={'star'}>*</i>邮箱验证码</span>}
                                                placeHolder={'请输入验证码'}
                                                tips={!codeOff
                                                    ? <span
                                                        className={reg.test(formData2.email) ? 'link' : 'disable'}
                                                        onClick={() => {
                                                            if (reg.test(formData2.email)) {
                                                                this.setState({
                                                                    codeOff: true
                                                                }, () => {
                                                                    this.sendCodeFn(1);
                                                                });
                                                            }
                                                        }}
                                                    >
                                                        获取验证码
                                                    </span>
                                                    : <span className={'disable'}>
                                                        {codeTime}s后重新发送
                                                    </span>
                                                }
                                                rules={
                                                    [
                                                        {
                                                            validate(value) {
                                                                let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                return v.length === 0;
                                                            },
                                                            message: '此项不能为空！'
                                                        }
                                                    ]
                                                }
                                                getValue={this.formItemGetValue2}
                                            /> */}
                                            <FormItem
                                                type="input"
                                                value={formData2.tel}
                                                spellCheck={false}
                                                name={'tel'}
                                                horizontal={true}
                                                label={<span><i className={'star'}>*</i>联系电话</span>}
                                                placeHolder={'请输入正确的手机号码用来接收通知'}
                                                rules={
                                                    [
                                                        {
                                                            validate(value) {
                                                                let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                return v.length === 0;
                                                            },
                                                            message: '此项不能为空！'
                                                        },
                                                        {
                                                            validate(value) {
                                                                return !reg1.test(value);
                                                            },
                                                            message: '手机格式不正确！'
                                                        }
                                                    ]
                                                }
                                                getValue={this.formItemGetValue2}
                                            />

                                            <FormItem
                                                type="input"
                                                value={formData2.tel_code}
                                                spellCheck={false}
                                                name={'tel_code'}
                                                horizontal={true}
                                                width={'120px'}
                                                label={<span><i className={'star'}>*</i>手机验证码</span>}
                                                placeHolder={'请输入验证码'}
                                                tips={!codeOff1
                                                    ? <span
                                                        className={reg1.test(formData2.tel) ? 'link' : 'disable'}
                                                        onClick={() => {
                                                            if (reg1.test(formData2.tel)) {
                                                                this.setState({
                                                                    codeOff1: true
                                                                }, () => {
                                                                    this.sendCodeFn(2);
                                                                });
                                                            }
                                                        }}
                                                    >
                                                        获取验证码
                                                    </span>
                                                    : <span className={'disable'}>
                                                        {telTime}s后重新发送
                                                    </span>
                                                }
                                                rules={
                                                    [
                                                        {
                                                            validate(value) {
                                                                let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                return v.length === 0;
                                                            },
                                                            message: '此项不能为空！'
                                                        }
                                                    ]
                                                }
                                                getValue={this.formItemGetValue2}
                                            />
                                            <div className={'form-check'}>
                                                <Checkbox
                                                    name="zzz2"
                                                    value="rrr2"
                                                    checked={checkboxValue2}
                                                    theme={'blue'}
                                                    getValue={e => {
                                                        this.setState({
                                                            checkboxValue2: e.checked
                                                        });
                                                        this.checked('checkboxValue2', e.checked);
                                                    }}
                                                >
                                                    <span>已阅读</span>
                                                    <a
                                                        href="https://haoma.baidu.com/privacy/agreement.html"
                                                        className={'link line'}
                                                        rel="noopener noreferrer"
                                                        target={'_blank'}>
                                                        《企业号码认证服务协议》
                                                    </a>
                                                    <span>和</span>
                                                    <a
                                                        href="https://haoma.baidu.com/privacy/index.html"
                                                        className={'link line'}
                                                        rel="noopener noreferrer"
                                                        target={'_blank'}>
                                                        《百度号码认证服务隐私政策》
                                                    </a>
                                                </Checkbox>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'form-btn'}>
                                        <div>
                                            <FormItem
                                                name={'f12'}
                                                className={'spui2-m-r10'}
                                                styleType={'ghost'}
                                                label={'取消'}
                                                type="button"
                                                onClick={() => {
                                                    this.setState({promptOff: true}, () => {
                                                        this.props.history.push('/attest');
                                                    });
                                                }}
                                            />
                                            {!Iscommit
                                                ? <Tips
                                                    title="输入所有必填项后可提交"
                                                    placement={'bottom-left'}
                                                    className={'leftip'}
                                                    preventOverflowEnabled={false}>
                                                    <FormItem
                                                        name={'f11'}
                                                        styleType={'modal'}
                                                        label={'提交'}
                                                        disabled={!Iscommit}
                                                        submitFlag={true}
                                                        type="button"
                                                    />
                                                </Tips>
                                                : <FormItem
                                                    name={'f11'}
                                                    styleType={'modal'}
                                                    label={'提交'}
                                                    disabled={!Iscommit}
                                                    submitFlag={true}
                                                    type="button"
                                                />

                                            }
                                        </div>

                                        {
                                            spinOff
                                                ? <div>
                                                    <Spin
                                                        type={'small'}
                                                        description={'正在检测当前数据是否正确，请稍等'}
                                                    />
                                                </div>
                                                : null
                                        }
                                    </div>
                                </Form>
                            </div>
                        </div>
                        <Viewmod phone={formData2.phone} name={formData2.display} modTop={modTop}/>
                    </div>
                    : null
                }
                {num === '2'
                    ? <Xmod backhandle={() => {
                        this.setState({promptOff: false}, () => {
                            this.props.history.push('/user_center/my_attest');
                        });
                    }}/>
                    : null
                }
                {
                    magnifyOff
                        ? <div
                            className={'magnify'}
                            onClick={() => {
                                this.setState({magnifyOff: false});
                            }}
                        >
                            <img
                                src={magnifySrc}
                                alt=""
                                onClick={e => {
                                    e.stopPropagation();
                                }}
                            />
                        </div>
                        : null
                }
                {num !== '2'
                && <Prompt
                    when={promptOff}
                    message={() =>
                        '是否不提交信息进行跳转？'
                    }
                />
                }
            </div>
        );
    }
}

AttestStep.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    fetchAuth: PropTypes.func,
    fetchSendCode: PropTypes.func,
    fetchCheckphone: PropTypes.func,
    userInfo: PropTypes.object
};

function mapStateToProps(state) {
    return {
        userInfo: state.userInfo
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchAuth: obj => fetchAuth(dispatch, obj),
        fetchSendCode: obj => fetchSendCode(dispatch, obj),
        fetchCheckphone: obj => fetchCheckphone(dispatch, obj)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AttestStep));